module.exports = __webpack_public_path__ + "static/media/assistant-bg.cb947f55.jpg";